module.exports = __webpack_public_path__ + "img/28.64e63afe.jpg";